export const experiment_file_to_keys = {
  sunpharma_paonta_sahib: {
    machine_view: {
      required: [
        "machine id",
        "start time",
        "end time",
        "test id"
      ],
      optional: []
    },
    analyst_view: {
      required: [
        "analyst id",
        "test id"
      ],
      optional: []
    },
    product_view: {
      required: [
        "product code",
        "batch no",
        "analyst id",
        "test id"
      ],
      optional: []
    },
    sla_matrix: {
      required: [],
      optional: []
    },
  }
};